import { CKContainerProps, CKCopyWell } from 'clearkit';
import { FC } from 'react';

import { useProfilePermissions } from '~/components/profile/useProfilePermissions';
import { SettingsCard } from '~/components/unified/SettingsCard';

type ApiKeysProps = {
  keyPublic: string;
  keySecret: string;
};

type HeadingProps = CKContainerProps & {
  title: string;
};

const Heading: FC<HeadingProps> = ({ children, title, ...rest }) => (
  <header {...rest}>
    <h2 className="mb-1 font-medium font-lg">{title}</h2>
    <p className="pb-2">{children}</p>
  </header>
);

export const APIKeys: FC<ApiKeysProps> = ({ keyPublic, keySecret }) => {
  const { isOwner } = useProfilePermissions();

  return (
    <SettingsCard>
      <SettingsCard.Header>
        <SettingsCard.Heading>API Keys</SettingsCard.Heading>
      </SettingsCard.Header>
      <SettingsCard.Body className="space-y-8 max-w-[50ch]">
        <section className="space-y-4">
          <Heading title="Secret API Key">
            Keep it safe–it's your key to the castle. If you need to get an API
            key changed or revoked, please{' '}
            <a className="ck-link" href="mailto:support@clearbit.com">
              contact us
            </a>
            .
          </Heading>
          <CKCopyWell
            hasViewableToggle
            isDisabled={!isOwner}
            value={keySecret}
          />
        </section>
        <section className="space-y-4">
          <Heading title="Publishable API Key">
            Use this key for the Reveal Google Analytics integration. For all
            other API access, use your secret key above.
          </Heading>
          <CKCopyWell value={keyPublic} />
        </section>
      </SettingsCard.Body>
    </SettingsCard>
  );
};
